import { useEffect, useState } from 'react';
import { listTruckClasses } from '../../reference-data/reference-data.api';

export interface TruckClassOption {
  value: string;
  label: string;
}

/** The active truck classes, fetched whole: a small fixed catalogue (CLAUDE.md → Lists and tables). `null` while loading. */
export function useTruckClassOptions(): TruckClassOption[] | null {
  const [options, setOptions] = useState<TruckClassOption[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    listTruckClasses()
      .then((classes) => !cancelled && setOptions(classes.filter((c) => c.isActive).map((c) => ({ value: c.code, label: c.name }))))
      .catch(() => !cancelled && setOptions([]));
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
}
